export type TelegramGroup = {
  city: string;
  description: string;
  username: string;
  url: string;
  kind: "main" | "offtop" | "city" | "state";
};

export const MAIN_TELEGRAM_URL = "https://t.me/itgermania";
export const MAIN_TELEGRAM_HANDLE = "@itgermania";

export const TELEGRAM_GROUPS: TelegramGroup[] = [
  {
    city: "Hauptgruppe",
    description:
      "Hier startet alles – stell dich kurz vor und finde Leute aus deiner Region.",
    username: "@itgermania",
    url: "https://t.me/itgermania",
    kind: "main",
  },
  {
    city: "Off-Topic",
    description: "Lockere Gespräche – alles abseits der IT-Themen.",
    username: "@offtop_it_germania",
    url: "https://t.me/offtop_it_germania",
    kind: "offtop",
  },
  {
    city: "Frankfurt",
    description: "Austausch und Treffen in Frankfurt und der Rhein-Main-Region.",
    username: "@itgermania_frankfurt",
    url: "https://t.me/itgermania_frankfurt",
    kind: "city",
  },
  {
    city: "Berlin",
    description: "Austausch und Treffen in Berlin und Umgebung.",
    username: "@itgermania_berlin",
    url: "https://t.me/itgermania_berlin",
    kind: "city",
  },
  {
    city: "München",
    description: "Austausch und Treffen in München und Umgebung.",
    username: "@itgermania_muenchen",
    url: "https://t.me/itgermania_muenchen",
    kind: "city",
  },
  {
    city: "Hamburg",
    description: "Austausch und Treffen in Hamburg und Umgebung.",
    username: "@itgermania_hamburg",
    url: "https://t.me/itgermania_hamburg",
    kind: "city",
  },
  {
    city: "Nordrhein-Westfalen",
    description:
      "Treffen in den größten Städten: Köln, Düsseldorf, Dortmund, Essen und Bonn.",
    username: "@itgermania_nrw",
    url: "https://t.me/itgermania_nrw",
    kind: "state",
  },
  {
    city: "Baden-Württemberg",
    description:
      "Treffen in den größten Städten: Stuttgart, Mannheim, Karlsruhe und Heidelberg.",
    username: "@itgermania_baden_wuerttemberg",
    url: "https://t.me/itgermania_baden_wuerttemberg",
    kind: "state",
  },
  {
    city: "Sachsen, Sachsen-Anhalt & Niedersachsen",
    description:
      "Treffen in den größten Städten: Hannover, Leipzig, Dresden, Braunschweig und Magdeburg.",
    username: "@itgermania_sachsen",
    url: "https://t.me/itgermania_sachsen",
    kind: "state",
  },
];
